import maxoptraNotificationResultsQuery from '../../queries/sales/MaxoptraNotificationResultsWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const MaxoptrNotificationResults: EntityType = {
  type: 'MaxoptraNotificationResult',
  title: 'Maxoptra Notification Results',
  workspace: maxoptraNotificationResultsQuery,
  workspaceUrl: '/Sales/Order/MaxoptraNotificationResults/',
  screenReference: 'MAXOPTRA_NOTIFICATIONS',
};

export default MaxoptrNotificationResults;
